import GridReportIdeiglenes from '../GridReportIdeiglenes/GridReportIdeiglenes';
import { languageElements } from './ReportDeliveries-languageElements';
import ReportDeliveriesFunctionCell from './ReportDeliveries-FunctionCell';
import { saveAs } from "file-saver";
import base64ToBlob from '../repository/base64ToBlob';

export default function ReportDeliveries(props) {
  async function downloadFiles(ordId, renderStatus) {
    renderStatus('LOADING');

    fetch(`${process.env.REACT_APP_API_BASE_URL}/data/files/deliveries`, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        token: props.loginData.getToken(),
        ordid: ordId,
      },
    })
      .then((data) => {
        if (data.status !== 200) {
          const error = new Error('invalid');
          error.status = data.status;
          throw error;
        }
        return data.json();
      })
      .then((jsonData) => {
        jsonData.documents.forEach(doc => {
          const blob = base64ToBlob(doc.imageData)
          saveAs(blob, doc.fileName)
        })
        renderStatus('');
      })
      .catch((err) => {
        console.error(err);
        renderStatus('ERROR');
      });
  };

  return (
    <div className='Deliveries'>
      <GridReportIdeiglenes
        id='ReportDeliveries'
        dataEndpoint='data/get'
        language={props.language}
        loginData={props.loginData}
        report={{
          reportId: '',
          languageElements: languageElements,
          sqlFromIdeiglenes: 'U_WAT_DELIVERIES',
          frameworkComponents: {
            ReportDeliveriesFunctionCell,
          },
          cellRenderers: [
            {
              field: "AttachedDocsParentId",
              cellRenderer: "ReportDeliveriesFunctionCell",
              cellRendererParams: {
                clicked: (ordId, reportDeliveriesFunctionCell) => downloadFiles(ordId, reportDeliveriesFunctionCell),
              },
            },
          ],

        }}
      />
    </div>
  );
}
